export const MuiFormLabel = {
    styleOverrides: {
        root: ({ theme }) => ({
            lineHeight: '1.5rem',
            fontWeight: theme.typography.fontWeightMedium,
            marginBottom: '.25rem',
        }),
    },
};
